module.exports = __webpack_public_path__ + "img/submit-button.24875801.png";